import axios from 'axios';

const host = process.env.VUE_APP_API_HOST;

const moduleNews = {
    namespaced: true,
    state: () => ({
        news: window.localStorage.getItem('news') != undefined ? JSON.parse(window.localStorage.getItem('news')) : [],
        nextPlayoutNews: window.localStorage.getItem('nextPlayoutNews') != undefined ? window.localStorage.getItem('nextPlayoutNews') : 0,
        readNews: window.localStorage.getItem('readNews') != undefined ? JSON.parse(window.localStorage.getItem('readNews')) : [],
    }),
    getters: {
        news: state => {
            return state.news;
        },
        unreadNews: state => {
            return state.news.filter((news) => {return news.show_tablet}).filter(entry => !state.readNews.includes(entry.id));
        },
        tabletNews: state => {
            return state.news.filter((news) => {return news.show_tablet});
        },
        playoutNews: state => {
            return state.news.filter((news) => {return news.show_playout});
        },
        nextPlayoutNews: state => {
            return parseInt(state.nextPlayoutNews);
        },
    },
    mutations: {
        /**
         * Set the state news
         * @param {object} state The state of the Vuex Store
         * @param {object} news The new value for news
         */
        setNews (state, {news}) {
            state.news = news;
            window.localStorage.setItem('news', JSON.stringify(state.news));
        },
        /**
         * Set the state news
         * @param {object} state The state of the Vuex Store
         * @param {object} news The new value for news
         */
        addReadNews (state, {news}) {
            if(state.readNews.findIndex((readNews) => {return news.id === readNews}) === -1) {
                state.readNews.push(news.id);
                window.localStorage.setItem('readNews', JSON.stringify(state.readNews));
            }
        },
        /**
         * Set the state nextPlayoutNews
         * @param {object} state The state of the Vuex Store
         * @param {object} nextPlayoutNews The new value for nextPlayoutNews
         */
        setNextPlayoutNews (state, {nextPlayoutNews}) {
            state.nextPlayoutNews = nextPlayoutNews;
            window.localStorage.setItem('nextPlayoutNews', state.nextPlayoutNews);
        },
    },
    actions: {
        /**
         * Calls the News@update api, and fill the state news 
         * @param {object} context Exposes the same set of methods/properties on the store instance
         * @return {Promise<object>}
         */
        fetchNews (context) {
            return new Promise((resolve, reject) => {
                let url = host + '/api/v1/news';
                axios.get(url).then((response) => {
                    context.commit('setNews', {'news': response.data});
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        
    }
}
export default moduleNews;